import React, { useState } from "react";
import Container from "../../components/Layout/Container";
import { QueryClient, QueryClientProvider } from "react-query";
import Products from "./components/Products";
import ProductMassImport from "./components/ProductMassImports";
import SuppliersManagement from "./components/SuppliersManagement/SuppliersManagement";
import NonPublishableKeywords from "./components/NonPublishableKeywords/NonPublishableKeywords";
import BrandMappings from "./components/BrandMappings/BrandMappings";

export const queryProductsClient = new QueryClient();

export default function ProductIndex({ match }) {
  const [tabId, setTabId] = useState("products");
  const [supplierName, setSupplierName] = useState("");

  const renderTabContent = () => {
    switch (tabId) {
      case "products":
        return <Products tabId={tabId} setTabId={setTabId} />;
      case "mass_import":
        return <ProductMassImport tabId={tabId} setTabId={setTabId} />;
      case "suppliers_management":
        return (
          <SuppliersManagement
            tabId={tabId}
            setTabId={setTabId}
            onSupplierNameChange={setSupplierName}
          />
        );
      case "non_publishable_keywords":
        return <NonPublishableKeywords tabId={tabId} setTabId={setTabId} />;
      case "brand_mappings":
        return <BrandMappings tabId={tabId} setTabId={setTabId} />;
      default:
        return null;
    }
  };

  const getLocation = () => {
    switch (tabId) {
      case "products":
        return {
          locationName: "Products",
          locationUrl: match.url,
        };
      case "mass_import":
        return {
          locationName: "Mass Import",
          locationUrl: match.url,
        };
      case "suppliers_management":
        return {
          locationName: supplierName
            ? `${supplierName}`
            : "Suppliers Management",
          locationUrl: "Suppliers Management",
        };
      case "non_publishable_keywords":
        return {
          locationName: "Non-Publishable Keywords",
          locationUrl: "Non-Publishable Keywords",
        };
      case "brand_mappings":
        return {
          locationName: "Brand mappings",
          locationUrl: "Brand mappings",
        };
      default:
        return {
          locationName: "Products",
          locationUrl: match.url,
        };
    }
  };

  const getBreadcrumbs = () => {
    const baseBreadcrumbs = [
      {
        label: "Products",
        value: match.url,
      },
    ];

    switch (tabId) {
      case "products":
        return baseBreadcrumbs;
      case "mass_import":
        return [
          ...baseBreadcrumbs,
          {
            label: "Mass Import",
            value: match.url,
          },
        ];
      case "suppliers_management":
        return [
          ...baseBreadcrumbs,
          {
            label: "Suppliers Management",
            value: match.url,
          },
          ...(supplierName
            ? [
                {
                  label: supplierName,
                  value: match.url,
                },
              ]
            : []),
        ];
      case "non_publishable_keywords":
        return [
          ...baseBreadcrumbs,
          {
            label: "Non-Publishable Keywords",
            value: match.url,
          },
        ];
      case "brand_mappings":
        return [
          ...baseBreadcrumbs,
          {
            label: "Brand mappings",
            value: match.url,
          },
        ];
      default:
        return baseBreadcrumbs;
    }
  };

  return (
    <Container location={getLocation()} breadcrumbs={getBreadcrumbs()}>
      <QueryClientProvider client={queryProductsClient}>
        {renderTabContent()}
      </QueryClientProvider>
    </Container>
  );
}
